import _get from "lodash/get";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Popover from '@nerdwallet/react-popover';
import Delete from '@nerdwallet/react-icon/gizmo/Delete';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';

var getImpressionProps = function getImpressionProps(productId) {
  return {
    id: "compare-bar-image-for-".concat(productId),
    elementName: "compare-bar-image-for-".concat(productId),
    sectionCategory: 'compare-bar',
    elementCategory: 'manual-card',
    elementDomType: 'img',
    verticalImpressionData: {
      productId: productId
    }
  };
};

var getCardImageClassName = function getCardImageClassName(isPortrait) {
  return classnames('card-image', {
    'card-image-portrait': isPortrait
  });
};

var CardImage = function CardImage(_ref) {
  var card = _ref.card,
      handleDelete = _ref.handleDelete;

  if (card && card.card_image) {
    var cardId = card.id;
    var cardImage = card.card_image;

    var source = _get(cardImage, 'source', null);

    if (source) {
      var altText = _get(cardImage, 'alt_text', '');

      var classes = getCardImageClassName(_get(cardImage, 'is_portrait', false));
      var popoverContent = /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: altText
        }
      });
      return /*#__PURE__*/React.createElement(Popover, {
        type: ['hover'],
        popoverContent: popoverContent,
        placement: "top",
        className: "popover-overlay-trigger",
        popoverClassName: "card-image-popover",
        key: "compare-card-image-".concat(cardId),
        id: "compare-card-popover-".concat(cardId)
      }, /*#__PURE__*/React.createElement(ElementImpression, getImpressionProps(cardId), /*#__PURE__*/React.createElement("img", {
        className: classes,
        src: source,
        alt: altText
      })), /*#__PURE__*/React.createElement(Delete, {
        className: "icon delete",
        onClick: function onClick() {
          return handleDelete(card.id);
        }
      }));
    }
  }

  return null;
};

CardImage.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
  card: PropTypes.object,
  handleDelete: PropTypes.func.isRequired
};
export default CardImage;